module.exports = __webpack_public_path__ + "img/align-right.9a9f4a60.svg";